var swiper = new Swiper(".block_slider-top-sale", {
    slidesPerView: 3,
    spaceBetween: 20,
    pagination: {
      el: ".block_slider-top-sale .swiper-pagination",
      clickable: true,
    },
   navigation: {
        nextEl: ".block_top-sale .block_slider-right-arrow",
        prevEl: ".block_top-sale .block_slider-left-arrow",
    },
    mousewheel: {
      forceToAxis: true,
  },
    breakpoints: { 
      320: {
        slidesPerView: 1,
        spaceBetween: 10     
      },    
      370: {
        slidesPerView: 2,
        spaceBetween: 10
      },  
      1280: {
        slidesPerView: 3   
      },           
      1499: {
        slidesPerView: 3
      }
    }
  });